// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class Interval {
    constructor(from, to) {
        this.From = from;
        this.To = to;
    }
    static GetInvalidInterval() {
        const invalidInterval = new Interval();
        invalidInterval.From = new Date(0);
        invalidInterval.To = new Date(0);
        return invalidInterval;
    }
}
